import { useState, useEffect } from "react";
import styled from "styled-components";

const generateRandomColor = () => {
    return `rgb(${30 + Math.random()*190},${30 + Math.random()*190},${30 + Math.random()*190})`;
  }

const generateRandomFontSize = () => {
    return 15 + Math.floor(Math.random() * 14) + 1;
}

const generateRandomSkew = () => {
    return `skew(${Math.random()*10}deg, ${Math.random()*10}deg)`;
}

const generateRandomTopPadding = () => {
    return `${Math.random() * 2}%`;
}

const generateRandomLeftPadding = () => {
    return `${Math.random() * 10}%`
}

const NumberContainer = styled.div`
    position: relative;
    width: 50px;
    height: 13px;
    margin: 5px;
    cursor: pointer;
`;

export const NumberHolder = ({ number, currentNumber, setCurrentNumber,disabled, level, shuffle, numbers, setNumberOfPickedNumbers, numberOfPickedNumbers}: any) => {
    const [isSolved, setIsSolved] = useState(false);

    const handleLevel3NumberClick = () => {
      setNumberOfPickedNumbers(numberOfPickedNumbers + 1);
      setCurrentNumber(numbers[numberOfPickedNumbers + 1]);
    };

    useEffect(() => {
    setIsSolved(false);
    },[shuffle,level])

    const [styles, setStyles] = useState({
      color: generateRandomColor(),
      fontSize: generateRandomFontSize(),
      transform: generateRandomSkew(),
      paddingTop: generateRandomTopPadding(),
      paddingLeft: generateRandomLeftPadding(),
    });

    const handleNumberClick = () => {
        if (currentNumber === number && !disabled) {
            level === 1 ? setCurrentNumber(currentNumber + 1) : level === 2 ? setCurrentNumber(currentNumber -1) : handleLevel3NumberClick();
            setIsSolved(true);
        }
    }
  return (
    <NumberContainer
      onClick={handleNumberClick}
      style={{...styles, color: level === 1 && isSolved ? "#eee" : styles.color}
      }
    >
      {number}
    </NumberContainer>
  );
};

export default NumberHolder;